export interface FinalSetupDataRow {
  id?: number;
  invoiceDate?: Date;
  invoiceNumber?: string;
  amount?: number;
  vatPercentage?: number;
  vatAmount?: number;
  amountIncludingVat?: number;
  isEditable?: boolean;
  finalSetupRowType?: FinalSetupRowType;
}

export interface AdditionalInvoiceDataRow extends FinalSetupDataRow {
  description?: string;
}

export interface DiscountDataRow extends FinalSetupDataRow {
  label: string;
  description: string;
}

export interface DeliveryDataRow extends FinalSetupDataRow {
  productId?: string;
  productName?: string;
  baseQuantity?: number;
  deliveryDate?: Date;
  deliveryId?: string;
}

export interface FinalSetupPrintRow extends FinalSetupDataRow {
  invoiceDateString?: string;
  description?: string;
}

export interface DeliveryPrintRow extends FinalSetupPrintRow {
  baseQuantity?: number;
  products: DeliveryDataRow[];
}

export interface FixedPriceCorrectionPrintRow extends FinalSetupPrintRow {
  pricePer100Kg: number;
}

export enum FinalSetupRowType {
  FeedDeliveries = 'FeedDeliveries',
  ChicksDeliveries = 'ChicksDeliveries',
  Departures = 'Departures',
  Discounts = 'Discounts',
}

export interface FixedPrice {
  pricePer100Kg?: number;
  invoiceNumber?: string;
  invoiceDate?: string;
  vatPercentage?: number;
}
